import { LanguageEnum } from '@/constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import { IPayloadChangeLanguageRequest } from './language.type';

const initialState = {
	language: '' as LanguageEnum,
};

const languageSlice = createSlice({
	initialState,
	name: 'language',
	reducers: {
		changeLanguageRequest: (
			state,
			action: PayloadAction<IPayloadChangeLanguageRequest>
		) => {
			state.language = action.payload.language;
		},
	},
});

export const LanguageSelectors = {
	selectLanguage: (state: RootState) => state.language.language,

	selectIsEnglish: (state: RootState) =>
		state.language.language === LanguageEnum.EN,
};

export const LanguageActions = languageSlice.actions;
export const LanguageReducer = languageSlice.reducer;
